import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { InputTextarea } from "primereact/inputtextarea";
import { useEffect, useRef, useState } from "react";
import { useAddDoctorNote, useDeleteDoctorNote, useGetDoctorNotes, useUpdateDoctorNote } from "../../hooks/useGetDataQuery";
import { useToastContext } from "../../Lib/Contexts/toastContext";
import { Divider } from "primereact/divider";
import { BlockUI } from "primereact/blockui";

const DoctorNotes = ({ selectedPatient, t }:any) => {
    const { showToast } = useToastContext();
    const [doctorNotes, setDoctorNotes] = useState<any[]>([]);
    const [noteError, setNoteError] = useState<any>("");
    const updateTextareaRef = useRef<any>(null);
    const [credentials, setCredentials] = useState<any>({
        doctorNotes: "",
        patientId: selectedPatient?.id || "",
        isItYoursNote: true,
    });
    const [updateCredentials, setUpdateCredentials] = useState<any>({
        doctorNotes: "",
        noteId: null
    })

    const {
        mutate: getDoctorNotes,
        isPending: isFetchingDoctorNotes,
    } = useGetDoctorNotes();

    const { 
        mutate: addDoctorNote, 
        isPending: isAdding, 
    } = useAddDoctorNote();

    const {
        mutate: deleteDoctorNote,
        isPending: isPendingDeleteDoctorNote
    } = useDeleteDoctorNote();

    const {
        mutate: updateDoctorNote,
        isPending: isPendingUpdateDoctorNote
    } = useUpdateDoctorNote();

    const handleUpdateDoctorNote = () => {
        updateDoctorNote(updateCredentials, {
            onSuccess: (data:any) => {
                if(data.success) {
                    setDoctorNotes((prev:any[]) => prev?.map((note:any) => {
                        if(note.noteId === updateCredentials?.noteId) {
                            return {
                                ...note,
                                doctorNotes: updateCredentials.doctorNotes,
                            }
                        }
                        return note;
                    }))
                    setUpdateCredentials({ doctorNotes: "", noteId: "" })
                    showToast({ severity: "success", summary: t("success"), detail: t("noteUpdated") });
                }
            },
            onError: () => {
                showToast({ severity: "error", summary: t("error"), detail: t("somethingWentWrong") })
            }
        })
    }

    const handleSave = () => {
        if(!credentials.doctorNotes || credentials.doctorNotes.trim() === "") {
            setNoteError("requiredField");
            return;
        }
        addDoctorNote(credentials, {
            onSuccess: (data:any) => {
                if(data.success) {
                    setDoctorNotes(prev => [...prev, data.data]);
                    setCredentials({ ...credentials, doctorNotes: "" });
                }
            },
            onError: (_) => {
                showToast({
                    severity: "error",
                    summary: t("error"),
                    detail: t("errorMessages.prescription.doctorNotes.doctorNotesSavingFailed"),
                });
            }
        });
    }

    const handleDelete = (noteId: string) => {
        deleteDoctorNote({ noteId }, {
            onSuccess: (data:any) => {
                if(data.success) {
                    setDoctorNotes(prev => prev.filter(note => note.noteId !== noteId));
                    showToast({ severity: "success", summary: t("success"), detail: t("doctorNoteDeleted") });
                }
            },
            onError: (error) => {
                showToast({
                    severity: "error",
                    summary: t("error"),
                    detail: error?.message || t("somethingWentWrong"),
                });
            }
        });
    }

    // function formatToMD(input: string | Date): string {
    //     const d = typeof input === 'string' ? new Date(input) : input;

    //     if (isNaN(d.getTime())) {
    //         throw new Error('Invalid date');
    //     }

    //     const month = d.getMonth() + 1;
    //     const day   = d.getDate();

    //     return `${month}.${day}`;
    // }

    useEffect(() => {
        if(selectedPatient?.id) {
            getDoctorNotes(selectedPatient.id, {
                onSuccess: (data:any) => {
                    if(data.success) {
                        setDoctorNotes(data.data || []);
                    }
                },
                onError: (error) => {
                    showToast({
                        severity: "error",
                        summary: t("error"),
                        detail: error?.message || t("somethingWentWrong"),
                    });
                }
            });
        }
    }, [selectedPatient]);

    const NoteCard = ({ note }:any) => (
      <div className="flex align-items-start gap-3">
        <div 
          style={{ 
            minWidth: '5rem',
            maxWidth: '5rem',
            height: "100%",
            fontSize: '0.875rem',
            position: 'relative',
            flexShrink: 0
          }}
        >
          <div className="flex flex-column align-items-center justify-content-center text-white font-bold" style={{ backgroundColor: '#64748b', height: "3.5rem", borderRadius: "10px" }}>
            <div>12.02</div>
            <div style={{ fontSize: '0.75rem' }}>2225</div>
          </div>
          <div 
            style={{
              position: 'absolute',
              left: '50%',
              height: '100%',
              borderLeft: '1.25px dashed #d1d5db',
              zIndex: 0
            }}
          />
        </div>
        <div className="flex-1" style={{ minWidth: 0 }}>
          <div className="flex flex-wrap align-items-center justify-content-between mb-2 gap-2">
            <h4 className="m-0 text-900 font-semibold" style={{ 
              flex: '1 1 auto', 
              minWidth: '10rem',
              maxWidth: '100%',
              wordWrap: 'break-word',
              overflowWrap: 'break-word',
              hyphens: 'auto'
            }}>
                Dr. {note.consultantFirstName} {note.consultantLastName}
            </h4>
            {note.isItYoursNote && (
                <div className="flex align-items-center justify-content-center gap-1" style={{ flexShrink: 0 }}>
                    <Button
                        className="p-button-rounded p-button-text"
                        style={{ 
                            backgroundColor: 'white',
                            width: '2rem',
                            height: '2rem',
                            minWidth: '2rem'
                        }}
                        onClick={() => handleDelete(note.noteId)}
                        loading={isPendingDeleteDoctorNote}
                    >
                        <img src="/redTrashIcon.svg" />
                    </Button>
                    {(updateCredentials?.noteId !== note.noteId) ? (<Button
                        className="p-button-rounded p-button-text"
                        style={{ 
                            backgroundColor: 'white',
                            width: '2rem',
                            height: '2rem',
                            minWidth: '2rem'
                        }}
                        onClick={() => setUpdateCredentials({ doctorNotes: note.doctorNotes, noteId: note.noteId })}
                    >
                        <img src="/editIcon.svg" />
                    </Button>) : (
                        <div className="flex align-items-center justify-content-center gap-1">
                            <Button
                                className="p-button-rounded p-button-text"
                                style={{ 
                                    backgroundColor: 'white',
                                    width: '2rem',
                                    height: '2rem',
                                    minWidth: '2rem'
                                }}
                                onClick={() => handleUpdateDoctorNote()}
                                loading={isPendingUpdateDoctorNote}
                            >
                                <img src="/completedIcon.svg" />
                            </Button>
                            <Button
                                className="p-button-rounded p-button-text"
                                style={{ 
                                    backgroundColor: 'white',
                                    width: '2rem',
                                    height: '2rem',
                                    minWidth: '2rem'
                                }}
                                onClick={() => setUpdateCredentials({ doctorNotes: "", noteId: null })}
                            >
                                <img src="/canceledIcon.svg" />
                            </Button>
                        </div>
                    )}
                </div>
            )}
          </div>
          {updateCredentials?.noteId === note.noteId ? (
            <div className="flex flex-column gap-1">
                <InputTextarea 
                    ref={updateTextareaRef}
                    disabled={isPendingUpdateDoctorNote}
                    autoResize 
                    id="update-note" 
                    className="p-3" 
                    placeholder={t("updateNote")} 
                    value={updateCredentials.doctorNotes} 
                    onChange={(e) => {
                        const cursorPosition = e.target.selectionStart;
                        setUpdateCredentials({ ...updateCredentials, doctorNotes: e.target.value });
                        setTimeout(() => {
                            if (updateTextareaRef.current) {
                                updateTextareaRef.current.focus();
                                updateTextareaRef.current.setSelectionRange(cursorPosition, cursorPosition);
                            }
                        }, 0);
                    }} 
                    rows={1} 
                    style={{ width: '100%', maxWidth: '100%' }}
                />
            </div>
           ) : (
              <div 
                className="p-3 text-900"
                style={{ 
                    backgroundColor: '#fef3c7',
                    fontSize: '14px',
                    lineHeight: '1.5',
                    whiteSpace: 'normal',
                    wordBreak: 'normal',
                    overflowWrap: 'anywhere'
                }}
              >
                {note.doctorNotes}
              </div>
           )}
        </div>
      </div>
  );

    return (
        <Card className="flex-grow-1 w-15rem relative" style={{ borderRadius: "15px", overflowY: "auto" }}>
            <div className="flex flex-column">
                <div className="flex flex-column gap-3">
                    <p className="m-0 text-lg font-bold" style={{ color: "#2D3967" }}>{t("doctorNotes")}</p>
                    <div className="flex flex-column gap-1">
                        <InputTextarea disabled={isAdding} autoResize id="new-note" className="p-3" placeholder={t("newNote")} value={credentials.doctorNotes} onChange={(e) => setCredentials({ ...credentials, doctorNotes: e.target.value })} rows={3} />
                        {(noteError && credentials.doctorNotes === "") && <small className="text-red-500">{t(noteError)}</small>}
                    </div>
                    <div className="flex justify-content-end">
                        <Button loading={isAdding} label={t("save")} onClick={() => handleSave()} style={{ backgroundColor: "#6383F4", borderRadius: "5px", border: 0, height: "1.875rem", width: "fit-content" }} />
                    </div>
                </div>
                <Divider />
                <BlockUI
                    blocked={isFetchingDoctorNotes}
                    style={{ backgroundColor: "transparent", borderRadius: "24px" }}
                    template={
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <dotlottie-player
                                src="https://lottie.host/102dcba8-b9a9-447a-af8e-3e134e77ea0c/Esb1U6xLam.lottie"
                                background="transparent"
                                speed="1"
                                style={{ width: "3rem", height: "3rem" }}
                                loop
                                autoplay
                            />
                        </div>
                    }
                >
                    <div className="flex flex-column gap-3">
                        {doctorNotes?.map((note, index) => (
                            <>
                                <NoteCard key={index} note={note} />
                                <Divider className="m-0" />
                            </>
                        ))}
                    </div>
                </BlockUI>
            </div>
        </Card>
    )
}

export default DoctorNotes;